import { Injectable, NgZone } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, exhaustMap, catchError, tap, withLatestFrom, mergeMap, filter, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromImageActions from '../actions/image.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { ErrorService } from '../../services/error.service';
import { setLoadingSpinner } from '../actions/shared.actions';
import { AlertService } from '../../services/alert.service';
import { AccountService } from 'src/app/services/account.service';
import { ModalController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';

@Injectable()
export class ImageEffects {

    getUploadUrl$ = createEffect(() =>
        this.actions$.pipe(
        ofType(fromImageActions.getUploadUrl),
        exhaustMap((action) =>
            this.accountService.getUploadURL('').pipe(
                map((response) => {
                    return fromImageActions.getUploadUrlSuccess({ data: response });
                    })
                )
            )
        )
    );

    getUploadUrlSuccess$ = createEffect(
        () =>
          this.actions$.pipe(
            ofType(fromImageActions.getUploadUrlSuccess),
            tap(async (action) => {
              console.log('getUploadUrlSuccess$', action?.data);
            })
          ),
        { dispatch: false }
      );

    uploadImageToS3$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromImageActions.uploadProfileImage),
            exhaustMap((action) =>
                this.accountService.uploadToS3(action.data).pipe(
                    map((response) => { 
                        console.log(response)
                        return fromImageActions.uploadProfileImageSuccess( response );
                    }),
                    catchError((response) => {
                        const error = {
                            status: response.status,
                            error: this.errorService.getErrorMessage(response)
                        };

                        return of(fromImageActions.uploadProfileImageFailed({ data: error }));
                    })
                )
            )
        )
    );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private errorService: ErrorService,
    private alertService: AlertService,
    private accountService: AccountService,
    private modalController: ModalController,
    private navCtrl: NavController,
    private authService : AuthService,
    private sharedService: SharedService,
    private ngZone: NgZone
  ) {}
}